<template>
    <div class="landmark-container" v-if="!landmark.isDeleted" @mouseover="mouseOver" @mouseleave="mouseleave"
        v-show="landmark.isTooth || landmark.isBone || landmark.isNerve || app.is3D" v-bind:style="{
        backgroundColor: landmark.isHovered ? '#007bff' : 'black', color: landmark.hasFigures ? 'white' : '#A9A9A9',
        flexDirection: landmark.isTooth ? 'column' : 'row'
    }">
        <div class="landmark-header">
            <img class="landmark-btn landmark-visible" v-on:click="isVisibleChanged()" title="Visible"
                :src="landmark.isVisible ? 'images/visible_on_white.png' : 'images/visible_off_white.png'" />
            <span class="landmark-color" ref="landmarkColor" :style="{ backgroundColor: landmark.color }"></span>
            <div class="an-name" :title="landmark.definition">{{ landmark.name }} ({{ landmark.abbreviation }})
            </div>
            <!-- <img class="landmark-btn landmark-focus" v-on:click="focusLandmarkClick()" title="Focus"
                :src="landmark.isFocused ? 'images/focus_red.png' : 'images/focus_white.png'" /> -->
            <img class="landmark-btn" v-on:click="editLandmarkClick()" title="Edit"
                :src="landmark.isEdited ? 'images/annotation_red.png' : 'images/annotation_white.png'" />
        </div>


    </div>
</template>

<script>
import swal from "sweetalert";
import {
    highlightLandmark, unhighlightLandmark,
    editLandmark, editToothSettings, focusLandmark,
    unfocusLandmark, updateLandmarkPosition, deleteLandmark
} from "./AnalysisManager";

export default {
    name: "DicomLandmark",
    props: {
        app: {
            type: Object,
            required: true
        },
        landmark: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            isMouseOver: false
        };
    },
    watch: {
        "landmark.isHovered": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    // console.log(`${this.landmark.name} hovered`, this.$el);
                    if (this.app.is3D) {
                        highlightLandmark(this.landmark);
                    }
                } else if (this.app.is3D) {
                    unhighlightLandmark(this.landmark);
                }
            }
        },
        "landmark.isClicked": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    if (!this.isMouseOver) {
                        this.$el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
                    }
                    this.landmark.isClicked = false;
                }
            }
        },
        "landmark.positionChanged": {
            // immediate: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    updateLandmarkPosition(this.app, this.landmark);
                }
            }
        },
    },
    methods: {
        mouseOver: function () {
            this.isMouseOver = true;
            if (!this.landmark.isTooth || this.app.isEditingLandmark)
                return;
            this.landmark.isHovered = true;
            // this.$refs.landmarkContainer.classList.add("mystyle")
            if (this.landmark.figures) {
                this.landmark.figures.forEach((figure) => {
                    if (figure.spline)
                        figure.spline.getChildren()[1].fill(this.landmark.color);
                });
            }

            if (this.landmark.childLandmarks) {
                this.landmark.childLandmarks.filter(a => a.figures).forEach((a) => {
                    a.figures.forEach((figure) => {
                        if (figure.spline)
                            figure.spline.getChildren()[1].fill(this.landmark.color);
                    });
                });
            }
        },
        mouseleave: function () {
            this.isMouseOver = false;
            if (!this.landmark.isTooth || this.app.isEditingLandmark)
                return;
            this.landmark.isHovered = false;
            if (this.landmark.figures) {
                this.landmark.figures.forEach((figure) => {
                    if (figure.spline)
                        figure.spline.getChildren()[1].fill('transparent');
                });
            }
            if (this.landmark.childLandmarks) {
                this.landmark.childLandmarks.filter(a => a.figures).forEach((a) => {
                    a.figures.forEach((figure) => {
                        if (figure.spline)
                            figure.spline.getChildren()[1].fill('transparent');
                    });
                });
            }
        },
        editSettings: function () {
            if (vueApp.isStitching) {
                swal({
                    text: "Cannot edit landmark settings while post processing.",
                });
                return;
            }
            if (!this.landmark.isTooth)
                return;
            editToothSettings(this.app, this.landmark);
        },
        editLandmarkClick: function () {
            this.landmark.isEdited = !this.landmark.isEdited;
            // editLandmark(this.app, this.landmark);
        },
        focusLandmarkClick: function () {
            this.landmark.isFocused = !this.landmark.isFocused;
            if (this.landmark.isFocused) {
                focusLandmark(this.app, this.landmark);
            } else {
                unfocusLandmark(this.app);
            }
        },
        isVisibleChanged: function () {
            this.landmark.isVisible = !this.landmark.isVisible;

            let focusedLandmark = this.app.landmarks.find((a) => a.isFocused);
            if (focusedLandmark && focusedLandmark != this.landmark)
                return;


            if (!this.landmark.isTooth)
                return;

            this.landmark.figures.forEach((figure) => {
                figure.konvaPoints.forEach((konvaPoint) => {
                    if (konvaPoint.anchor) {
                        if (this.landmark.isVisible)
                            konvaPoint.anchor.show();
                        else
                            konvaPoint.anchor.hide();
                    }
                });
                if (figure.spline) {
                    if (this.landmark.isVisible)
                        figure.spline.show();
                    else
                        figure.spline.hide();
                }

            });
            if (this.landmark.childLandmarks) {
                this.landmark.childLandmarks.filter(a => a.figures).forEach((a) => {
                    a.figures.forEach((figure) => {
                        if (figure.spline) {
                            if (this.landmark.isVisible)
                                figure.spline.show();
                            else
                                figure.spline.hide();
                        }
                    });
                });
            }
        },
        removeLandmark: function () {
            if (!this.landmark.isTooth)
                return;
            swal({
                text: "Are you sure you want to delete this landmark?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(willDelete => {
                if (willDelete) {
                    console.log("deleteLandmark");
                    this.landmark.hasFigures = false;
                    deleteLandmark(this.app, this.landmark);
                    if (this.landmark.childLandmarks) {
                        this.landmark.childLandmarks.forEach((landmark) => {
                            let app = this.app.childApps.find(c => c.index == landmark.appIndex);
                            deleteLandmark(app, landmark);
                        });
                    }

                }
            });
        }
    }
}

</script>

<style scoped>
.landmark-container {
    color: white;
    padding: 0.2rem;
    border: solid white 0.1rem;
    display: flex;
    gap: 3px;
    /* flex-direction: column; */
}

.landmark-header {
    display: flex;
    align-items: stretch;
    gap: 5px;
    width: 100%;
}

.landmark-tools {
    display: flex;
    align-items: stretch;
    gap: 14px;
    margin-left: 3px;
}

.landmark-selected {
    display: block;
}

.landmark-color {
    margin-top: 2px;
    margin-left: 8px;
    height: 20px;
    width: 20px;
    min-height: 20px;
    min-width: 20px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
}

.landmark-download {
    margin-top: 3px;
    height: 20px;
    width: 20px;
    cursor: pointer;
    /* display: inline-block; */
}

.an-name {
    margin-top: 1px;
    white-space: nowrap;
    /* text-wrap: nowrap; */
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    flex-grow: 1;
    max-width: calc(100% - 68px);
}

.landmark-btn {
    margin-top: 1px;
    height: 20px;
    width: 20px;
    cursor: pointer;
}

.landmark-visible {
    margin-top: 0px;
    height: 25px;
    width: 25px;
}

.landmark-focus {
    margin-top: 0px;
    height: 23px;
    width: 23px;
}

.landmark-settings {
    margin-top: 2px;
}
</style>